import type * as React from 'react'

/**
 * A link that opens beside the form. Nothing on a wizard step is saved until
 * Next, so following a link in the same tab would throw away what was typed.
 */
export function NewTabLink({
  href,
  className,
  children,
}: {
  href: string
  className?: string
  children: React.ReactNode
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {children}
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  )
}
